import React from "react";

const TemarioDiplomaturaInnovacionDigital = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"La era digital como oportunidad para la salud"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Transformación digital en salud: contexto global y regional"}</span></li>
                <li><span className="fw-light">{"Qué cambia y qué no cambia"}</span></li>
                <li><span className="fw-light">{"Tecnologías de la información y las comunicaciones como herramienta para mejorar el sistema de salud"}</span></li>
                <li><span className="fw-light">{"Introducción a la inteligencia artificial"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nuevas culturas profesionales y liderazgo en salud digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Nuevos hábitos y competencias"}</span></li>
                <li><span className="fw-light">{"Barreras y facilitadores de la adopción tecnológica,"}</span></li>
                <li><span className="fw-light">{"Liderazgo adaptativo y gestión del cambio"}</span></li>
            </ul>
            <br /><br />
            <b>{"Comunicación en la era digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Comunicación efectiva y asertiva"}</span></li>
                <li><span className="fw-light">{"Documentación y claridad de mensajes"}</span></li>
                <li><span className="fw-light">{"Consentimiento informado como proceso clínico y legal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Historia clínica electrónica y cultura del registro"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Qué es una HCE y para qué sirve"}</span></li>
                <li><span className="fw-light">{"Cultura del registro, calidad del dato y trazabilidad"}</span></li>
                <li><span className="fw-light">{"Soporte a la decisión clínica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Interoperabilidad, estándares y visión 360 del paciente"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"¿Qué es interoperar? ¿Por qué es clave"}</span></li>
                <li><span className="fw-light">{"Estándares: HL7, FHIR, SNOMED CT, LOINC, DICOM"}</span></li>
                <li><span className="fw-light">{"Tablas maestras, gobierno de datos, visión longitudinal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Seguridad, protección de datos y marco legal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Legislación nacional e internacional"}</span></li>
                <li><span className="fw-light">{"Ciberseguridad, privacidad, consentimiento"}</span></li>
                <li><span className="fw-light">{"Rol profesional en la protección de la información"}</span></li>
            </ul>
            <br /><br />
            <b>{"Salud digital asistencial: telesalud y nuevos modelos de atención"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Teleconsulta, telediagnóstico, telepsicología"}</span></li>
                <li><span className="fw-light">{"Plataformas, apps y seguimiento remoto"}</span></li>
                <li><span className="fw-light">{"Experiencias regionales y barreras"}</span></li>
            </ul>
            <br /><br />
            <b>{"Portales del paciente y herramientas de autogestión"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Funciones de los portales: turnos, resultados, comunicación"}</span></li>
                <li><span className="fw-light">{"Herramientas para la adherencia y el autocuidado"}</span></li>
                <li><span className="fw-light">{"Interacciones asincrónicas y monitoreo continuo"}</span></li>
            </ul>
            <br /><br />
            <b>{"Herramientas digitales para la gestión clínica y administrativa"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Agendamiento inteligente y programación"}</span></li>
                <li><span className="fw-light">{"Gestión de recursos: consultorios, quirófanos, equipos"}</span></li>
                <li><span className="fw-light">{"Integración de la atención y la logística"}</span></li>
            </ul>
            <br /><br />
            <b>{"Inteligencia artificial y agentes asistenciales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Modelos de lenguaje grandes y pequeños"}</span></li>
                <li><span className="fw-light">{"Agentes conversacionales y automatización de tareas"}</span></li>
                <li><span className="fw-light">{"IA como apoyo clínico y herramienta para humanizar"}</span></li>
            </ul>
            <br /><br />
            <b>{"Identidad digital y marketing profesional en salud"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Marca personal, visibilidad ética y reputación"}</span></li>
                <li><span className="fw-light">{"Redes sociales, plataformas y posicionamiento"}</span></li>
                <li><span className="fw-light">{"Oportunidades y riesgos del profesional conectado"}</span></li>
            </ul>
            <br /><br />
            <b>{"Innovación, proyectos y mejora en salud digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Design thinking y metodologías ágiles"}</span></li>
                <li><span className="fw-light">{"Diseño de proyectos de mejora o implementación"}</span></li>
                <li><span className="fw-light">{"Presentación final de ideas o propuestas"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaInnovacionDigital;
